import React, { useState, useEffect, useContext, useRef } from 'react';
import { Link, useParams } from 'react-router-dom';
import { DndProvider, useDrag, useDrop } from 'react-dnd';
import { HTML5Backend } from 'react-dnd-html5-backend';
import { Modal, Button } from 'react-bootstrap';
import Icon3 from '../../assest/images/Icon3.png';
import Icon5 from '../../assest/images/Icon5.png';
import Icon4 from '../../assest/images/Icon4.png';
import accept from '../../assest/images/accept.png';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import CustomDropdown from '../common/CustomDropdown';
import SCPConfigDropdown from '../common/SCPConfigDropdown';
import CustomSingleValue from '../common/CustomSingleValue';
import config from "../../envconfig";
import { UserContext } from '../common/UserContext';
import Select from 'react-select';
import { IoCaretUpOutline, IoCaretDownOutline } from 'react-icons/io5';
import { set } from 'date-fns';

const SCPConfig = () => {
  const { UM_GroupId, UM_CompanyGrpID, selectedScpId, UM_CompanyID, UM_UserId, UM_UserCode, UM_DefaultSCPId } = useContext(UserContext);
  const [companyOptions, setCompanyOptions] = useState([]);
  const [company, setCompany] = useState('');
  const [scpName, setScpName] = useState('');
  const [scpTable, setScpTable] = useState([]);
  const [disabledOptions, setDisabledOptions] = useState([]);
  const [errors, setErrors] = useState({});
  const [selectedSCPIndex, setSelectedSCPIndex] = useState(null);
  const [suspendConfirmationModal, setSuspendConfirmationModal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [isSelectOpen, setIsSelectOpen] = useState(null);
  const [loading, setLoading] = useState(false);
  const [showEditWarningIndex, setShowEditWarningIndex] = useState(null);
  const EMPTY_SCP_LEVEL_TOAST_ID = 'empty-scp-level-name';
  const caretRef = useRef(0);



  useEffect(() => {
    const input = document.activeElement;
    if (input && input.tagName === 'INPUT') {
      const pos = caretRef.current;
      input.setSelectionRange(pos, pos);
    }
  }, [scpTable]);


  useEffect(() => {
    fetchCompanyOptions();
    fetchDisabledOptions();
  }, []); // Fetch options on component mount

  useEffect(() => {
    sessionStorage.setItem('UM_GroupId', UM_GroupId);
    sessionStorage.setItem('UM_CompanyGrpID', UM_CompanyGrpID);
    sessionStorage.setItem('UM_DefaultSCPId', UM_DefaultSCPId);
    sessionStorage.setItem('UM_CompanyID', UM_CompanyID);
    sessionStorage.setItem('UM_UserId', UM_UserId);
    sessionStorage.setItem('UM_UserCode', UM_UserCode);
    sessionStorage.setItem('selectedScpId', selectedScpId);
  }, [UM_GroupId, UM_CompanyGrpID, UM_DefaultSCPId, UM_CompanyID, UM_UserId, UM_UserCode, selectedScpId]);

  const handleSelectOpen = (selectName) => {
    setIsSelectOpen(selectName);
  };

  const handleSelectClose = () => {
    setIsSelectOpen(null);
  };


  const logAction = async (action, isError = false) => {
    try {
      const response = await fetch(`${config.API_URL}/api/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ module: "SCP-Configuration:", action, userCode: UM_UserCode, isError }),
      });
      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const logAudit = async (module, message, oldValue = "", newValue = "", isError = false, transactionDetails = []) => {
    const auditLogPayload = {
      AUTR_ScreenName: module,
      AUTR_OldValue: oldValue,
      AUTR_NewValue: newValue,
      AUTR_Message: message,
      AUTR_UserID: UM_UserId,
      AUTR_UserName: UM_UserCode,
      AUTR_AuditType: 14,
      AUTR_SCPID: selectedScpId,
      AUTR_CompanyGrpId: UM_CompanyGrpID,
      AUTR_CompanyID: UM_CompanyID,
      AUTR_CreatedBy: UM_UserId,
      insertAuditTransaction: transactionDetails.length > 0,
      transactionDetails
    };

    try {
      const response = await fetch(`${config.API_URL}/audit/log`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(auditLogPayload),
      });

      if (!response.ok) {
        throw new Error('Failed to log action');
      }
    } catch (error) {
      console.error('Error logging action:', error);
    }
  };

  const fetchCompanyOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/SCPCONFIG/CGNAME`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      if (data.success) {
        logAction("fetchCompanyOptions():Company group names fetched successfully");
        setCompanyOptions(data.data);
      } else {
        logAction("fetchCompanyOptions(): failed to fetch company group names", true);
        throw new Error(data.error || 'Failed to fetch options');
      }
    } catch (error) {
      console.error('Error fetching company options:', error);
      logAction("fetchCompanyOptions(): Error fetching company group name ", true);
    }
  };

  const fetchDisabledOptions = async () => {
    try {
      const response = await fetch(`${config.API_URL}/api/scpmaster`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const data = await response.json();
      if (data.success) {
        logAction("fetchDisabledOptions(): already configured companyGroupNames fetched successfully");
        setDisabledOptions(data.data);
      } else {
        logAction("fetchDisabledOptions():Failed to disable already configured company group names", true);
        throw new Error(data.error || 'Failed to fetch disabled options');
      }
    } catch (error) {
      logAction("fetchDisabledOptions():Failed to disable already configured company group names", true);
      console.error('Error fetching disabled options:', error);
    }
  };

  const handleAllowMultipleOutwardChange = (index, value) => {
    const updatedTable = [...scpTable];
    updatedTable[index].allowMultiplePartyOutward = value;
    setScpTable(updatedTable);
  };

  const handleAllowMultipleSameLevelChange = (index, value) => {
    const updatedTable = [...scpTable];
    updatedTable[index].allowMultiplePartySameLevel = value;
    setScpTable(updatedTable);
  };

  const handleCompanyChange = (selectedOption) => {
    setCompany(selectedOption ? selectedOption.value : '');
    setErrors((prev) => ({ ...prev, company: false }));
  };

  const validateScpName = (value) => {
    if (!value || value.trim() === '') {
      return '';
    }
    console.log("validateScpName called with value length:", value.length);
    if (value.length > 45) {
      return 'Maximum 45 characters allowed';
    }

    // Only allowed characters
    if (!/^[A-Za-z0-9\-_ ]+$/.test(value)) {
      return 'Please use only special characters like -, _, and space';
    }

    // First & last character must be alphanumeric (ignore single char case)
    if (
      value.length > 1 &&
      (!/^[A-Za-z0-9]/.test(value) || !/[A-Za-z0-9]$/.test(value))
    ) {
      return 'First and Last character must be alphanumeric';
    }

    // No consecutive special characters (including mixed)
    if (/[\-_. ]{2,}/.test(value)) {
      return 'Consecutive special characters are not allowed';
    }

    return '';
  };

  const handleScpNameChange = (e) => {
    let inputValue = e.target.value;

    // Hard limit to 50 chars
    if (inputValue.length > 50) {
      inputValue = inputValue.slice(0, 50);
    }

    setScpName(inputValue);
    setErrors((prev) => ({ ...prev, scpName: '' }));
    setErrorMessage(validateScpName(inputValue));
  };

  const handleAddRow = () => {
    setLoading(true);
    let newErrors = {};
    let isValid = true;
    const trimmedScpName = (scpName || '').trim();

    if (!company || !trimmedScpName) {
      logAction("handleAddRow():Trying to add with empty company group name or scp name", true);
      newErrors = {
        ...newErrors,
        company: !company,
        scpName: !trimmedScpName,
      };
      isValid = false;
    }

    if (scpTable.some(row => row.scpName.trim().toLowerCase() === trimmedScpName.toLowerCase())) {
      logAction("handleAddRow():Trying to add SCP name which is already there in the table", true);
      toast.error(`SCP Level Name : ${trimmedScpName} already exists.`, { onClose: () => { setLoading(false); } });
      return;
    }

    if (!isValid) {
      setLoading(false);
      setErrors(newErrors);
      return;
    }

    //const validationMessage = validateScpName(scpName);
    if (validateScpName(trimmedScpName)) {
      logAction('handleAddRow():Invalid SCP name', true);
      setLoading(false);
      return;
    }
    const newRow = {
      scpLevelNo: scpTable.length + 1,
      scpName: trimmedScpName,
      allowMultiplePartyOutward: 'No',
      allowMultiplePartySameLevel: 'No',
    };
    setScpTable([...scpTable, newRow]);
    setScpName('');
    setErrors({});
    setLoading(false);
    logAction("handleAddRow():New Record added successfully in the table");
  };

  const handleEditRow = (index) => {
    logAction('handleEditRow():started');
    setShowEditWarningIndex(null);
    const updatedTable = [...scpTable];
    updatedTable[index]._scpName = updatedTable[index].scpName;
    updatedTable[index]._allowMultiplePartyOutward = updatedTable[index].allowMultiplePartyOutward;
    updatedTable[index]._allowMultiplePartySameLevel = updatedTable[index].allowMultiplePartySameLevel;
    updatedTable[index].isEditing = true;
    setScpTable(updatedTable);
    caretRef.current = updatedTable[index].scpName.length;
    setErrors({});
    logAction('handleEditRow():ended');
  };

  const handleSaveEdit = (index) => {
    logAction('handleSaveEdit():started');

    let newErrors = {};
    let isValid = true;

    const scpName = scpTable[index].scpName;
    const editedName = (scpName || '').trim();
    console.log("scpName:", scpName);

    if (!editedName) {
      logAction('handleSaveEdit():Empty SCP name not allowed', true);
      newErrors[`scpName${index}`] = 'SCP Level Name is required';
      isValid = false;
    }

    const validationMessage = validateScpName(editedName);
    if (isValid && validationMessage) {
      logAction(`handleSaveEdit():Invalid scpname ${scpName}`, true);
      newErrors[`scpName${index}`] = validationMessage;
      isValid = false;
    }

    if (
      isValid &&
      scpTable.some((row, i) => row.scpName.trim().toLowerCase() === editedName.toLowerCase() && i !== index)
    ) {
      logAction(
        `handleSaveEdit():SCP Name ${scpName} already exists in the table`,
        true
      );
      newErrors[`scpName${index}`] = 'SCP Name already exists in the table';
      isValid = false;
    }

    if (!isValid) {
      logAction('handleSaveEdit():Validation failed', true);
      setErrors(newErrors);
      setShowEditWarningIndex(index);
      return;
    }

    const updatedTable = [...scpTable];
    updatedTable[index].scpName = editedName;
    updatedTable[index].isEditing = false;
    setScpTable(updatedTable);
    setShowEditWarningIndex(null);
    setErrors({});

    logAction('handleSaveEdit():ended');
  };


  const handleCancelEdit = (index) => {
    logAction('handleCancelEdit():started');
    const updatedTable = [...scpTable];
    updatedTable[index].scpName = updatedTable[index]._scpName;
    updatedTable[index].allowMultiplePartyOutward = updatedTable[index]._allowMultiplePartyOutward;
    updatedTable[index].allowMultiplePartySameLevel = updatedTable[index]._allowMultiplePartySameLevel;
    updatedTable[index].isEditing = false;
    setScpTable(updatedTable);
    setErrors({});
    logAction('handleCancelEdit():ended');
  };

  const moveRow = (dragIndex, hoverIndex) => {
    if (isAnyRowEditing) return; // Block any reordering while editing

    const draggedRow = scpTable[dragIndex];
    const updatedTable = [...scpTable];
    updatedTable.splice(dragIndex, 1);
    updatedTable.splice(hoverIndex, 0, draggedRow);
    updatedTable.forEach((row, index) => {
      row.scpLevelNo = index + 1;
    });
    setScpTable(updatedTable);
  };

  const isAnyRowEditing = scpTable.some(row => row.isEditing);

  const TableRow = ({ row, index }) => {
    const [{ isDragging }, drag] = useDrag({
      type: 'ROW',
      item: { index },
      canDrag: () => !isAnyRowEditing,        // Critical: disables drag when editing
      collect: (monitor) => ({
        isDragging: monitor.isDragging(),
      }),
    });

    const [, drop] = useDrop({
      accept: 'ROW',
      hover: (item) => {
        if (isAnyRowEditing || !item) return;  // Block hover/reordering during edit
        const dragIndex = item.index;
        const hoverIndex = index;
        if (dragIndex === hoverIndex) return;
        moveRow(dragIndex, hoverIndex);
        item.index = hoverIndex;
      },
    });

    const opacity = isDragging ? 0.5 : 1;

    // Only attach drag/drop when NOT editing anywhere
    const rowRef = isAnyRowEditing ? null : (node) => drag(drop(node));

    const outwardOptions = [
      { id: 'Yes', name: 'Yes' },
      { id: 'No', name: 'No' },
    ];

    return (
      <tr
        ref={rowRef}
        style={{
          opacity,
          cursor: isAnyRowEditing ? 'default' : 'move',
        }}
      >
        <td>{row.scpLevelNo}</td>
        <td>
          {row.isEditing ? (
            <div style={{ display: 'flex', alignItems: 'center', gap: '6px' }}>
              <input
                type="text"
                value={row.scpName}
                onChange={(e) => {
                  const input = e.target;

                  caretRef.current = input.selectionStart;
                  console.log("caretRef.current:", caretRef.current);

                  let inputValue = input.value;
                  if (inputValue.length > 50) {
                    inputValue = inputValue.slice(0, 50);
                  }

                  setScpTable(prev => {
                    const updated = [...prev];
                    updated[index] = {
                      ...updated[index],
                      scpName: inputValue
                    };
                    return updated;
                  });

                  const errorMessage = validateScpName(inputValue);
                  setErrors(prev => ({
                    ...prev,
                    [`scpName${index}`]: errorMessage,
                  }));

                  if (inputValue.trim() !== '') {
                    setShowEditWarningIndex(null);
                  }
                }}
                autoFocus
                className="form-input"
                maxLength={50}
              />
              {showEditWarningIndex === index && row.isEditing && (
                <span style={{ color: 'red', fontWeight: 'bold' }}>*</span>
              )}
            </div>

          ) : (
            row.scpName
          )}
        </td>

        <td>
          <div className='select-container_list'>
            <SCPConfigDropdown
              options={outwardOptions}
              value={row.allowMultiplePartyOutward}
              onChange={(e) => handleAllowMultipleOutwardChange(index, e.target.value)}
              name={`allowMultiplePartyOutward${index}`}
              idKey="id"
              displayKey="name"
              disabled={isAnyRowEditing}
              enableScrollEffect={index === scpTable.length - 1 && index > 1}
            />
          </div>
        </td>
        <td>
          <div className='select-container_scpconfig'>
            <SCPConfigDropdown
              options={outwardOptions}
              value={row.allowMultiplePartySameLevel}
              onChange={(e) => handleAllowMultipleSameLevelChange(index, e.target.value)}
              name={`allowMultiplePartySameLevel${index}`}
              idKey="id"
              displayKey="name"
              disabled={isAnyRowEditing}
              enableScrollEffect={index === scpTable.length - 1 && index > 1}
            />
          </div>
        </td>
        <td style={{ paddingLeft: '18px' }}>
          {row.isEditing ? (
            <>
              <img
                src={accept}
                alt="save"
                title='Save'
                className="suspendicon"
                style={{ cursor: 'pointer' }}
                onClick={() => handleSaveEdit(index)}
              />
              <img
                src={Icon5}
                alt="cancel"
                title='Cancel'
                className="suspendicon"
                style={{ cursor: 'pointer' }}
                onClick={() => handleCancelEdit(index)}
              />
            </>
          ) : (
            <>
              <img
                src={Icon3}
                alt="Edit"
                title='Edit'
                className="editicon"
                style={{
                  cursor: isAnyRowEditing ? 'not-allowed' : 'pointer',
                  opacity: isAnyRowEditing ? 0.5 : 1
                }}
                onClick={() => !isAnyRowEditing && handleEditRow(index)}
              />
              <img
                src={Icon5}
                alt="suspend"
                title='Remove'
                //className="suspendicon"
                style={{
                  cursor: isAnyRowEditing ? 'not-allowed' : 'pointer',
                  opacity: isAnyRowEditing ? 0.5 : 1,
                  marginLeft: '10px',
                  paddingRight: '5px'
                }}
                onClick={() => !isAnyRowEditing && handleRemoveRow(index)}
              />
            </>
          )}
        </td>
      </tr>
    );
  };

  const handleSubmit = async (e) => {
    logAction('handleSubmit():started');
    e.preventDefault();

    if (isAnyRowEditing) {
      const editingIndex = scpTable.findIndex(r => r.isEditing);
      setShowEditWarningIndex(editingIndex);
      return;
    }

    let newErrors = {};
    let isValid = true;

    if (!company) {
      logAction("handleSubmit():Trying to submit with empty company group name", true);
      newErrors = {
        ...newErrors,
        company: !company,
      };
      isValid = false;
    }

    if (!scpName && scpTable.length === 0) {
      logAction("handleSubmit():Trying to submit with no SCP names in the table", true);
      newErrors = {
        ...newErrors,
        scpName: !scpName,
      };
      isValid = false;
    }

    if (scpTable.some(row => row.isEditing)) {
      logAction('handleSubmit():Trying to save with edit process going on for scp name in table', true);
      toast.error(`Please save or cancel the SCP Level Name Edit before submitting.`);
      return;
    }

    if (!isValid) {
      setErrors(newErrors);
      return;
    }

    if (scpTable.length === 0) {
      if (!toast.isActive(EMPTY_SCP_LEVEL_TOAST_ID)) {
        toast.error("Please add at least one SCP Level Name.", {
          toastId: EMPTY_SCP_LEVEL_TOAST_ID,
          onClose: () => { setLoading(false); }
        });
      }
      
      logAction('handleSubmit():Trying to save with no scp names in the table', true);
      return;
    }

    const dataToSend = scpTable.map(row => ({
      SCP_CompanyGrpID: company,
      SCP_LevelNo: row.scpLevelNo,
      SCP_LevelName: row.scpName,
      SCP_AllowMutliplePartySameLevelOutward: row.allowMultiplePartySameLevel === 'Yes' ? 1 : 0,
      SCP_AllowMutliplePartyOutward: row.allowMultiplePartyOutward === 'Yes' ? 1 : 0,
      SCP_Createdby: UM_UserId,
      SCP_ModifiedBy: UM_UserId,
    }));

    try {
      setLoading(true);
      const response = await fetch(`${config.API_URL}/api/scpconfiguration`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify(dataToSend)
      });

      if (!response.ok) {
        throw new Error('Network response was not ok');
      }

      const responseData = await response.json();
      if (responseData.success) {

        toast.success(`Configuration for Company Group Name : ${getCompanyGroupName(parseInt(company))} saved successfully.`, {
          onClose: () => {
            setCompany('');
            setScpName('');
            setScpTable([]);
            setErrors({});
            setLoading(false);
          }
        });
        logAction("handleSubmit():Data saved successfully in the database");
        fetchCompanyOptions();
        fetchDisabledOptions();

        const transactionDetails = [
          {
            AUTRN_ParamererName: "SCP Configuration Details",
            AUTRN_OldValue: "-",
            AUTRN_NewValue: JSON.stringify(scpTable.map(row => ({
              "SCP Level No.": row.scpLevelNo,
              "SCP Level Name": row.scpName,
              "SCP Allow Mutliple Party Outward": row.allowMultiplePartyOutward,
              "SCP Allow Same Level Mutliple Party Outward": row.allowMultiplePartySameLevel,
            })))
          }
        ];

        logAudit("SCP Configuration", `SCP Configuration for ${getCompanyGroupName(parseInt(company))} Saved Successfully in database`, '-', `${getCompanyGroupName(parseInt(company))}`, false, transactionDetails);

        // setCompany('');
        // setScpName('');
        // setScpTable([]);
        // setErrors({});
      } else {
        setLoading(false);
        throw new Error(responseData.message || 'Failed to insert data');
      }

    } catch (error) {
      console.error('Error inserting data:', error.message);
      setLoading(false);
      //toast.error("Some problem occurred during saving the configuration");
    }

    logAction('handleSubmit():ended');
  };

  const handleReset = () => {
    setCompany('');
    setScpName('');
    setScpTable([]);
    setErrors({});
    setErrorMessage('');
    logAction('handleReset():Page is reset by user');
    setLoading(false);
  };

  function getCompanyGroupName(CGM_ID) {
    const matchingOption = companyOptions.find(option => option.CGM_ID === CGM_ID);
    return matchingOption ? matchingOption.CGM_CompanyGroupName : '';
  }

  const handleCloseModal = () => {
    setSuspendConfirmationModal(false);
    setSelectedSCPIndex(null);
  };

  const handleRemoveRow = (index) => {
    setShowEditWarningIndex(null);
    setSelectedSCPIndex(index);
    setSuspendConfirmationModal(true);
  };

  const handleConfirmSuspend = () => {
    if (selectedSCPIndex !== null) {
      const updatedTable = scpTable.filter((_, i) => i !== selectedSCPIndex)
        .map((row, index) => ({
          ...row,
          scpLevelNo: index + 1
        }));
      setScpTable(updatedTable);
      setSelectedSCPIndex(null);
    }
    setShowEditWarningIndex(null);
    setSuspendConfirmationModal(false);
  };

  return (
    <form autoComplete="off">

      <ToastContainer style={{
        marginTop: '73px',
        fontSize: '14px',
        width: '40%',
      }} />
      {loading && (
        <div
          style={{
            position: "fixed",
            inset: 0,
            zIndex: 1000,
          }}
        />
      )}

      <div className='main_container' onKeyDown={(e) => {
    if (e.key === "Enter") {
      e.preventDefault();
      e.stopPropagation();
    }
  }}>
        <h1 className='formHeading'>SCP Configuration</h1>

        <div className='row'>
          <div className='col-sm-5'>
            <div className="label-input-container">
              <label className='form-label'>
                Company Group Name {errors.company && <span style={{ color: 'red' }}>*</span>}
              </label>
              <div className='select-container'>
                <Select
                  className="routing_select-box"
                  classNamePrefix="react-select"
                  options={companyOptions.map(option => ({
                    value: option.CGM_ID,
                    label: option.CGM_CompanyGroupName,
                    isDisabled: disabledOptions.includes(option.CGM_ID)
                  }))}
                  value={companyOptions
                    .map(option => ({
                      value: option.CGM_ID,
                      label: option.CGM_CompanyGroupName
                    }))
                    .find(opt => opt.value === company) || null}
                  onChange={handleCompanyChange}
                  placeholder="--Select--"
                  onMenuOpen={() => handleSelectOpen('CM_CompanyGrpId')}
                  onMenuClose={handleSelectClose}
                  maxMenuHeight="140px"
                  isDisabled={isAnyRowEditing}
                  components={{ SingleValue: CustomSingleValue }}
                />
                <div className='icon-container_list myList'>
                  <i>
                    {isSelectOpen === 'CM_CompanyGrpId' ? <IoCaretUpOutline /> : <IoCaretDownOutline />}
                  </i>
                </div>
              </div>
            </div>
          </div>
          <div className='col-sm-6'>
            <label htmlFor="scpName" className="form-label">SCP Level Name {errors.scpName && <span style={{ color: 'red' }}>*</span>}</label>
            <input
              type="text"
              id="scpName"
              value={scpName}
              onChange={handleScpNameChange}
              placeholder="Enter SCP Level Name"
              className="form-input"
              maxLength={45}
              disabled={isAnyRowEditing}
            />
            {errorMessage && <div style={{ color: 'red' }}>{errorMessage}</div>}
          </div>
          <div className='col-sm-1'>
            <button
              type="button"
              onClick={handleAddRow}
              className="scp_add_btn"
              disabled={isAnyRowEditing}
              style={{
                cursor: isAnyRowEditing ? "default" : "pointer",
                opacity: isAnyRowEditing ? 0.6 : 1
              }}
            >
              ADD
            </button>
          </div>

        </div>

        <div>
          {scpTable.length > 0 && (
            <DndProvider backend={HTML5Backend}>
              <table className="scpconfigtableClass mt-5">
                <thead>
                  <tr>
                    <th>SCP Level No</th>
                    <th>SCP Level Name</th>
                    <th>Allow Multiple Party Outward</th>
                    <th>Allow Same Level Multiple Party Outward</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {scpTable.map((row, index) => (
                    <TableRow key={row.id} row={row} index={index} />
                  ))}
                </tbody>
              </table>
            </DndProvider>
          )}
        </div>
      </div>
      <div className='button-container'>
        <button
          type="button"
          className='save_btn'
          // disabled={isAnyRowEditing}
          style={{
            cursor: isAnyRowEditing ? "default" : "pointer"
          }}
          onClick={handleSubmit}
        >
          SAVE
        </button>

        <button
          type="button"
          onClick={handleReset}
          className='reset_btn'
          disabled={isAnyRowEditing}
          style={{
            cursor: isAnyRowEditing ? "default" : "pointer"
          }}
        >
          RESET
        </button>

        <Link
          to={isAnyRowEditing ? '#' : `/scpconfiglist`}
          className='list_btn'
          onClick={(e) => { if (isAnyRowEditing) e.preventDefault(); }}
          style={{
            cursor: isAnyRowEditing ? "default" : "pointer",
            pointerEvents: isAnyRowEditing ? "none" : "auto"
          }}
        >
          LIST
        </Link>
      </div>



      {suspendConfirmationModal && (
        <div className="popup_overlay">
          <div className="resetpopup">
            <h1>:: User Confirmation ::</h1>
            <h4>Are you sure you want to remove SCP Configuration : {scpTable[selectedSCPIndex]?.scpName} ?</h4>
            <div className="popup_btn_container">
              <button className="yes_btn " onClick={handleConfirmSuspend}>
                YES
              </button>
              <button className="no_btn " onClick={handleCloseModal}>
                NO
              </button>
            </div>
          </div>
        </div>
      )}
    </form>
  );
};

export default SCPConfig;
